<template>
  <ya-site-resource-list resource="log" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteApiLogList',
  components: { YaSiteResourceList },
}
</script>
